export default "__VITE_ASSET__DyPCV$vx__"